import { createApiAction, createAction } from '@saucelabs/sl-util-redux';

import * as api from './api';
import * as generalAPI from './../general/api';
import * as types from './types';

export const cleanupOverview = createAction(types.CLEANUP_OVERVIEW);

export const getTrends = createApiAction(
  types.GET_TEST_TRENDS,
  (params) => generalAPI.getTrends(params),
  { meta: { skipErrorPage: true } },
);

export const getPastTrends = createApiAction(
  types.GET_PAST_TRENDS,
  (params) => generalAPI.getTrends(params),
  { meta: { skipErrorPage: true } },
);

export const getTestHealth = createApiAction(
  types.GET_TEST_HEALTH,
  (params) => api.getTestHealth(params),
  { meta: { skipErrorPage: true } },
);

export const getPastHealth = createApiAction(
  types.GET_PAST_HEALTH,
  (params) => api.getTestHealth(params),
  { meta: { skipErrorPage: true } },
);
